import { render, staticRenderFns } from "./chaptertestpaper.vue?vue&type=template&id=2b379d70"
import script from "./chaptertestpaper.vue?vue&type=script&lang=js"
export * from "./chaptertestpaper.vue?vue&type=script&lang=js"
import style0 from "./chaptertestpaper.vue?vue&type=style&index=0&id=2b379d70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports